import React from 'react';
import { Reveal } from './ui/Reveal';
import { PRODUCT, modules } from '../data/content';
export function SystemSection() {
  return <section aria-labelledby="solucion" className="bg-navy" data-id="element-148" data-mp="3gihmlebyhoow">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-149" data-mp="3bidfgewxu6bc">
        <Reveal className="text-center" data-id="element-150" data-mp="3bkpuaj7eg0k6">
          <h2 id="solucion" className="mx-auto max-w-3xl font-display text-lg font-black uppercase leading-[1.1] text-white sm:text-2xl lg:text-3xl" data-id="element-151" data-mp="36iqsvev7zdpv">
            La solución que estabas buscando —{' '}
            <span className="text-gold" data-id="element-152" data-mp="2wrw5g768m82u">un sistema 6 en 1</span>
          </h2>
          <p className="mt-1 text-[0.8rem] font-bold text-ivory sm:text-[0.95rem]" data-id="element-153" data-mp="2st6sugt0wuk9">
            6 módulos en un solo sistema, creados para aprender inglés desde
            cero.
          </p>
          <p className="mt-1 font-display text-base font-black uppercase tracking-wide text-gold sm:text-lg" data-id="element-154" data-mp="2iswhz2ugnz89">
            📘 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl text-[0.75rem] leading-snug text-ivory sm:text-[0.85rem]" data-id="element-155" data-mp="13z7ybboaqqqz">
            No es simplemente otro ebook de inglés. Es una ruta de aprendizaje
            que organiza los conocimientos fundamentales para que comprendas qué
            aprender primero, qué viene después y cómo comenzar a utilizar el
            idioma en situaciones reales.
          </p>
        </Reveal>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-156" data-mp="1mp65zqo6mhu3">
          {modules.map((mod, i) => <Reveal key={mod.label} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-gold/25 border-t-2 border-t-gold bg-navy-deep p-3" data-id="element-157" data-mp="1rp29zpwvq99n" data-mpi={i}>
              <span className="self-start rounded bg-gold px-2 py-0.5 text-[0.62rem] font-extrabold uppercase tracking-wide text-navy sm:text-[0.68rem]" data-id="element-158" data-mp="1horx66erb3v0">
                {mod.label}
              </span>
              <h3 className="mt-1.5 font-display text-[0.85rem] font-bold uppercase leading-tight text-white sm:text-[0.95rem]" data-id="element-159" data-mp="6cr0847qo946">
                {mod.title}
              </h3>
              <p className="mt-1 text-[0.73rem] leading-snug text-ivory sm:text-[0.8rem]" data-id="element-160" data-mp="240cq6pjsb6hc">
                {mod.desc}
              </p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}